module.exports = __webpack_public_path__ + "img/MTABAPPVITALS.78d43ef1.svg";